import React from "react";
import { faArrowLeft, faArrowRight } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Header } from "semantic-ui-react";
import InspectionTypeScheduleCalendarUtils from "../utils/InspectionTypeScheduleCalendarUtils";
import { CalendarDate } from "@internationalized/date";

interface IInspectionTypeCalendarWeekControls {
  date: CalendarDate;
  onRightClick: () => void;
  onLeftClick: () => void;
}
export default function InspectionTypeScheduleCalendarWeekControls({
  date,
  onLeftClick,
  onRightClick,
}: IInspectionTypeCalendarWeekControls) {
  const displayText = InspectionTypeScheduleCalendarUtils.getWeekControlsText(date);

  return (
    <div>
      <Header className='tw-font-serif tw-mt-0 tw-text-base tw-font-medium md:tw-absolute'>INSPECTION SCHEDULE</Header>
      <div className='tw-mb-2 tw-flex tw-flex-grow tw-items-center tw-justify-center'>
        <Button onClick={onLeftClick} circular className='tw-bg-transparent'>
          <FontAwesomeIcon icon={faArrowLeft} />
        </Button>
        <Button onClick={onRightClick} circular className='tw-bg-transparent'>
          <FontAwesomeIcon icon={faArrowRight} />
        </Button>
        <div className='tw-text-lg'>{displayText}</div>
      </div>
    </div>
  );
}
